import { FC, useState } from 'react';
import { withRouter } from 'react-router-dom';
import ROUTES from '../../../constants/routes';
import InteractiveLogo from '../../../images/interactive-logo.svg';
import translation, { world } from '../../../languages';
import { AVAILABLE_WORLDS } from '../../../languages/constants';
import isMobileAppWebview from '../../../utils/is-mobile-app-webview';
import isUITest from '../../../utils/is-ui-test';
import session from '../../../utils/session';
import SharedModal from '../../shared-modal/shared-modal';
import InteractiveBadge from '../interactive-badge/interactive-badge';
import './interactive-feature-announcement-popup.scss';

const InteractiveFeatureAnnouncementPopup: FC<TranslationProps> = ({ t }) => {
    const popupToBeShown = (): boolean => {
        const wasShown = window.storage.getItem('interactiveAnnouncementShown');

        return (
            !wasShown &&
            session.isLoggedIn() &&
            (world === AVAILABLE_WORLDS.ES || world === AVAILABLE_WORLDS.FR) &&
            !isUITest() &&
            !isMobileAppWebview()
        );
    };

    const buttonConfig = [
        {
            action: () => {
                // const urls = {
                //     [AVAILABLE_WORLDS.ES]: ROUTES.INTERACTIVE_ADJUSTMENT_LANDING.path,
                //     [AVAILABLE_WORLDS.FR]: ROUTES.INTERACTIVE_MAIN_LANDING.path
                // };

                window.storage.setItem('interactiveAnnouncementShown', 1);
                window.locationReload(ROUTES.INTERACTIVE_MAIN_LANDING.path);
            },
            className: 'transparent styled position-relative',
            text: (
                <>
                    {t('common.interactiveAnnouncementPopup.button1')}
                    <InteractiveBadge />
                </>
            )
        }
        // {
        //     action: () => {
        //         window.storage.setItem('interactiveAnnouncementShown', 1);
        //         window.locationReload(makeUrl(ROUTES.SEARCH_RESULT.path, {}, { f: 0 }));
        //     },
        //     className: 'transparent styled',
        //     text: t('common.interactiveAnnouncementPopup.button2')
        // }
    ];
    const [showModal, setShowModal] = useState(popupToBeShown());

    const handleClose = () => {
        window.storage.setItem('interactiveAnnouncementShown', 1);
        setShowModal(false);
    };

    const body = () => {
        return (
            <div>
                <div className='text-center'>
                    <img alt='' src={InteractiveLogo} />
                </div>
                <p className='mt-3'>{t('common.interactiveAnnouncementPopup.description')}</p>
            </div>
        );
    };

    return showModal ? (
        <SharedModal
            body={body()}
            btnConfig={buttonConfig}
            dialogClassName='interactive-feature-announcement-popup'
            title={<></>}
            onClose={handleClose}
        />
    ) : null;
};

const translate = translation('common');

export default withRouter(translate(InteractiveFeatureAnnouncementPopup));
